/**
 * A document with a bar chart inside — the Reporting module's tabular business
 * reports, as distinct from the PDF Generator's image-led brochures (PdfIcon).
 * Drawn in the same feather-ish outline style as `FileTextIcon`.
 */
const ReportIcon = props => (
  <svg
    width={37}
    height={37}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="currentColor"
    strokeLinecap="round"
    {...props}
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="8" y1="18" x2="8" y2="14" />
    <line x1="12" y1="18" x2="12" y2="11" />
    <line x1="16" y1="18" x2="16" y2="15" />
  </svg>
);

export default ReportIcon;
